import { Container, Row, Col, Card, CardBody } from "reactstrap";
import Slider from "react-slick";
import { AiFillDollarCircle } from "react-icons/ai";
import { BsFillMortarboardFill } from "react-icons/bs";
import { FaChevronRight } from "react-icons/fa6";
import { FaChevronLeft } from "react-icons/fa6";

const Program = () => {

  const listProgram = [
    { name:"Business & Social Sciences (Associate / Diploma)", desc:"Cocok buat kamu yang mau karier di bisnis, pemasaran, akuntansi, manajemen.", img:"assets/images/program1.webp", degree:"Diploma/Associate", tuition:"CAD $12,600 - $13,330 / tahun" },
    { name:"Health & Human Services", desc:"Ideal buat yang mau kerja di healthcare, childcare, atau social support roles.", img:"assets/images/program2.webp", degree:"Diploma / Certificate", tuition:"CAD $13,535 - $14,670 / tahun" },
    { name:"Trades & Technical Skills", desc:"Skill teknis yang laku keras di banyak industri.", img:"assets/images/program3.webp", degree:"Certificate / Apprenticeship", tuition:"CAD $12,600 - $16,000 / tahun" },
    { name:"Practical Nursing Diploma", desc:"Bidang spesialis yang jarang dan bernilai tinggi dan berkarir di healthcare / nursing", img:"assets/images/program4.webp", degree:"Diploma / Certificate", tuition:"CAD $18,460 - $21,880 / tahun" },
  ]

  const NextArrow = ({ onClick }) => {
    return (
      <div className="custom-arrow next" onClick={onClick}>
        <FaChevronRight size={24} />
      </div>
    );
  };

  const PrevArrow = ({ onClick }) => {
    return (
      <div className="custom-arrow prev" onClick={onClick}>
        <FaChevronLeft size={24} />
      </div>
    );
  };

  const settings = {
    className: "center",
    dots: true,
    infinite: true,
    speed: 500,
    
    centerMode: false,
    centerPadding: "0px",
    slidesToShow: 4,
    slidesToScroll: 4,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,     
    responsive: [   
      {
        breakpoint: 768,
        settings: {
          centerMode: false,
          centerPadding: "0px",
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },        
      {
        breakpoint: 480,
        settings: {
          centerMode: true,
          centerPadding: "35px",
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },            
    ],    
  };

  return (
    <>
      <section className="section" id="program">
        <Container>
          <Row className="">
            <Col className="">
              <div className="slide-wrapper">
                <h1 className="mb-3"><b>Program Studi Unggulan</b></h1>
                  <Slider {...settings}>
                    {listProgram.map((item, id) =>(
                      <Card key={id} className=''>
                        <img
                          alt={item.name}
                          src={item.img}
                          className="img-fluid"
                        />
                        <CardBody>
                          <div className="row">
                            <div className="col-1">
                            <BsFillMortarboardFill color="#00072E" />
                            </div>
                            <div className="col">
                            <p>{item.name}</p>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-1">
                            <AiFillDollarCircle color="#00072E" />
                            </div>
                            <div className="col">
                            <p>{item.tuition}</p>
                            </div>
                          </div>     
                          <div className="mt-3">{item.desc}</div>                 
                        </CardBody>
                      </Card>
                    ))}
                  </Slider>
                <p className="note">*Catatan biaya akan berbeda per program karena dihitung per kredit / contact hour - jadi jumlah total tergantung jumlah SKS yang kamu ambil.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Program;